import http, { API_CORE } from '../../http';

export default function ShoppingCartServiceV2() {
  const getCartItemsIds = async () => {
    const response = await http(API_CORE).get('/v2/shopping-carts/ids');
    return response.data;
  };

  const getCartItems = async () => {
    const response = await http(API_CORE).get('/v2/shopping-carts');
    return response.data;
  };

  const createCart = async ({ productVariantId, quantity }) => {
    const response = await http(API_CORE).post('/v2/shopping-carts', {
      productVariantId,
      quantity,
    });
    return response.data.shoppingCart;
  };

  const updateCartCount = async ({ id, quantity }) => {
    const response = await http(API_CORE).patch(`/v2/shopping-carts/${id}`, {
      quantity,
    });
    return response.data.shoppingCart;
  };

  const deleteCart = async ({ id }) => {
    const response = await http(API_CORE).delete(`/v2/shopping-carts/${id}`);
    return response.data;
  };

  const bulkDeleteCartItems = async ({ productVariantIds }) => {
    const response = await http(API_CORE).delete('/v2/shopping-carts/bulk', {
      data: { productVariantIds },
    });
    return response.data;
  };

  return {
    getCartItemsIds,
    getCartItems,
    createCart,
    updateCartCount,
    deleteCart,
    bulkDeleteCartItems,
  };
}
